// extracted by mini-css-extract-plugin
export var indexMiddleText = "navigation-module--indexMiddleText--26NVd";
export var indexNavigation = "navigation-module--indexNavigation--2za4q";
export var indexNavigation2 = "navigation-module--indexNavigation2--1HDhS";
export var indexNavigationBox = "navigation-module--indexNavigationBox--pHGVA";
export var indexNavigationBoxIcon = "navigation-module--indexNavigationBoxIcon--3j8lj";
export var indexNavigationBoxText = "navigation-module--indexNavigationBoxText--8rqKn";
export var indexNavigationHidden = "navigation-module--indexNavigationHidden--2j54v";